<template>
  <div id="reportsTypeComponent">
  <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout justify-end>
        <v-btn v-if="show" @click="reporte" :loading="loadingDownload" round outline color="primary" dark class="text-xs-center">
          <v-icon left>cloud_download</v-icon>
          {{$t('expenseDetailEmployee.download')}}
        </v-btn>
        <v-btn v-if="show" @click="downloadZipDialog = true" round outline color="primary" dark class="text-xs-center">
          <v-icon left>get_app</v-icon>
          {{$t('general.downloadExpensesFiles')}}
        </v-btn>
      </v-layout>
      <v-layout style="padding-bottom: 10px;">
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedStatus" :items="status" :label="$t('general.status')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo>
            <template slot="selection" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
            <template slot="item" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedCategory" :items="categories" :label="$t('general.categories')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedProject" :items="projects" :label="$t('general.projects')" :rules="rules.required" item-value="id" item-text="name" class="fixed-height" solo>
            <template slot="item" slot-scope="data">
              {{ data.item.name }} - {{ data.item.status === 1 ? $t('projects.stat.active') : $t('projects.stat.inactive')}}
            </template>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedArea" :items="areas" :label="$t('general.areas')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedEmployee" :items="employees" :label="$t('expenseDetailEmployee.employee')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :rules="rules.required"
                v-model="startDate"
                :label="$t('general.startDate')"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :max="new Date().toISOString().substr(0, 10)"
              v-model="startDate"
              @input="menu = false"
              :locale="$t('reportsType.local')"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :rules="rules.required"
                v-model="finishDate"
                :label="$t('general.endDate')"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              v-model="finishDate"
              @input="menu2 = false"
              :max="new Date().toISOString().substr(0, 10)"
              :min="startDate"
              :locale="$t('reportsType.local')"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-btn @click="search()" depressed :disabled="loading" :loading="loading" color="primary" round>
          <v-icon>search</v-icon>
          {{$t('general.search')}}
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchReport"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
      </v-layout>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-data-table
        v-if="!loadingItems"
        :search="searchReport"
        class="elevation-5"
        :headers="headers"
        :items="concepts.reportData ? concepts.reportData.categories : []"
        :loading="loadingItems"
        :no-data-text="$t('expenseDetailEmployee.noResults')"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination">
        <template v-slot:no-data v-if="concepts.reportData ? concepts.reportData.categories : []">
          <center class="subtitle font-weight-light">{{$t('general.noDataText')}}</center>
        </template>
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <!-- <tr v-for="i in props.item.gst_expenses_items" :key="i.id"> -->
            <tr>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ currencyFormat(props.item.subtotal) }}</td>
            <td class="text-xs-center">{{ calcImp(props.item.impuestos) | formatCurrency }}</td>
            <td class="text-xs-center">{{ currencyFormat(props.item.discount) }}</td>
            <td class="text-xs-center">{{ currencyFormat(props.item.total_tip) }}</td>
            <td class="text-xs-center">{{ currencyFormat(props.item.total) }} </td>
            <td class="text-xs-center">MXN</td>
            <!-- <td class="text-xs-center" v-for="a in contador" :key="a.id">${{ a }}</td> -->
          </tr>
        </template>
        <template v-slot:footer v-if="concepts && show">
          <td class="text-xs-center">
            <strong>Gastos totales</strong>
          </td>
          <td class="text-xs-center">
            <strong>{{ currencyFormat(concepts.reportData ? concepts.reportData.subtotal : '') }}</strong>
          </td>
          <td class="text-xs-center">
            <strong>{{ calcImp(concepts.reportData ? concepts.reportData.impuestos : '') | formatCurrency }}</strong>
          </td>
          <td class="text-xs-center">
            <strong>{{ currencyFormat(concepts.reportData ? concepts.reportData.discount : '') }}</strong>
          </td>
          <td class="text-xs-center">
            <strong>{{ calcTips(concepts.reportData ? concepts.reportData.categories : '') | formatCurrency }}</strong>
          </td>
          <td class="text-xs-center">
            <strong>{{ currencyFormat(concepts.reportData ? (+concepts.reportData.total) + (+totalTipAll) : '') }}</strong>
          </td>
          <td class="text-xs-center">
            <strong>MXN</strong>
          </td>
        </template>
      </v-data-table>
      <v-dialog
        v-model="downloadZipDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('general.downloadExpensesFiles')}}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form
              ref="valDownload"
              lazy-validation
              >
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    :items="zipsAvailables"
                    item-value="month"
                    v-model="selectedZip"
                    :label="$t('general.availableFiles')"
                    return-object
                    :rules="rules.required"
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      ({{startDate.substr(0, 4) + '-' + data.item.month}}) {{$t('general.expensesFiles')}}
                    </template>
                    <template slot="item" slot-scope="data">
                      ({{startDate.substr(0, 4) + '-' + data.item.month}}) {{$t('general.expensesFiles')}}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              round
              @click="closeDownloadDialog"
            >{{$t('general.close')}}</v-btn>
            <v-btn
              color="primary"
              depressed
              round
              @click="downloadFiles()"
              :loading="loading"
              :disabled="loading"
            >{{$t('general.download')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'reportsTypeComponent',
  data () {
    return {
      startDate: new Date().toISOString().substr(0, 8) + '01',
      finishDate: new Date().toISOString().substr(0, 10),
      searchReport: '',
      switchAllAreas: true,
      switchAllCategories: true,
      switchAllEmployees: true,
      switchAllProjects: true,
      switchAllStatus: true,
      concepts: [],
      userLogged: {},
      menu: false,
      menu2: false,
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      dialog: false,
      valid: true,
      loading: false,
      loadingItems: true,
      areas: [],
      employees: [],
      projects: [],
      status: [],
      categories: [],
      selectedArea: null,
      selectedCategory: null,
      selectedEmployee: null,
      selectedProject: null,
      selectedStatus: null,
      downloadZipDialog: false,
      show: false,
      detailedData: [],
      expensesItems: null,
      selectedZip: null,
      valDownload: true,
      totalTipAll: 0,
      loadingDownload: false
    }
  },
  computed: {
    heading () {
      return this.$t('reportsType.name')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: this.$t('reportsType.category'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('reportsType.subtotal'),
          align: 'center',
          value: 'subtotal',
          sortable: true
        },
        {
          text: this.$t('reportsType.iva'),
          align: 'center',
          value: 'iva',
          sortable: true
        },
        {
          text: this.$t('reportsType.descount'),
          align: 'center',
          value: 'discount',
          sortable: true
        },
        {
          text: this.$t('expenses.tip'),
          align: 'center',
          value: 'total_tip',
          sortable: true
        },
        {
          text: this.$t('reportsType.total'),
          align: 'center',
          value: 'total',
          sortable: true
        },
        {
          text: this.$t('reportsType.currency'),
          align: 'center',
          value: 'currency'
        }
      ]
    },
    rules () {
      return this.$validationRules()
    },
    zipsAvailables () {
      if (this.expensesItems && this.expensesItems.length > 0) {
        let startMonth = this.startDate.substr(5, 2)
        let endMonth = this.finishDate.substr(5, 2)
        let filtro = this.expensesItems.filter(item => item.month >= startMonth && item.month <= endMonth)
        return filtro
      }
    }
  },
  created () {
    this.getLogged()
    // this.initialize()
    // this.getReport()
  },
  watch: {
    '$store.state.userLogged' () {
      this.getLogged()
    },
    userLogged () {
      if (this.userLogged.company) {
        this.getAreasCompany()
        this.getCategories()
        this.getEmployees()
        this.getProjects()
        this.getStatus()
        this.search()
      }
    },
    status() {
      if (this.status !== undefined && this.status.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allStatus') }
        this.selectedStatus = -1
        this.status.unshift(objDefault)
      }
    },
    projects () {
      if (this.projects !== undefined && this.projects.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allProjects') }
        this.selectedProject = -1
        this.projects.unshift(objDefault)
      }
    },
    areas () {
      if (this.areas !== undefined && this.areas.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allAreas') }
        this.selectedArea = -1
        this.areas.unshift(objDefault)
      }
    },
    categories () {
      if (this.categories !== undefined && this.categories.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allCategories') }
        this.selectedCategory = -1
        this.categories.unshift(objDefault)
      }
    },
    employees () {
      if (this.employees !== undefined && this.employees.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allEmployees') }
        this.selectedEmployee = -1
        this.employees.unshift(objDefault)
      }
    },
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    currencyFormat (val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(val)
    },
    calcImp (val) {
      let total = 0
      let taxs = []
      if (val) {
        taxs = Object.getOwnPropertyNames(val)
      }
      for (let i = 0; i < taxs.length - 1; i++) {
        const name = taxs[i]
        if (val[name] !== undefined) {
          total += parseFloat(val[name])
        }
      }
      return total
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    close () {
      this.dialog = false
      this.loading = false
      this.$refs.form.resetValidation()
    },
    send () {
      if (this.$refs.form.validate()) {
        this.search()
      }
    },
    search () {
      this.show = true
      this.loading = true
      this.url = `${this.$store.state.userLogged.area[0].company_id}/${this.startDate}/${this.finishDate}?type=json`
      if (this.selectedArea > 0) {
        this.url += `&area_id=${this.selectedArea}`
      }

      if (this.selectedCategory > 0) {
        this.url += `&category_id=${this.selectedCategory}`
      }

      if (this.selectedEmployee > 0) {
        this.url += `&employee_id=${this.selectedEmployee}`
      }

      if (this.selectedProject > 0) {
        this.url += `&project_id=${this.selectedProject}`
      }
      
      if (this.selectedStatus > 0) {
        this.url += `&status_id=${this.selectedStatus}`
      }

      this.$emit('send', {
        context: this,
        items: {
          url: this.url
        }
      })
    },
    getAreasCompany () {
      this.$emit('getAreasCompany', {
        context: this,
        item: {
          companyId: this.userLogged.company[0].id
        }
      })
    },
    getCategories () {
      this.$emit('getCategories', {
        context: this
      })
    },
    getEmployees () {
      this.companyId = this.userLogged.company[0].id
      this.getAreasCompany()
      this.$emit('getEmployees', {
        context: this,
        item: {
          companyId: this.companyId
        }
      })
    },
    getProjects () {
      this.$emit('getProjects', {company_id: this.$store.state.userLogged.company[0].id, context: this})
    },
    getStatus () {
      this.$emit('getStatus', {
        context: this
      })
    },
    reset () {
      this.$refs.form.reset()
      // setTimeout(() => {
      //   this.format_sub = 0,
      //   this.format_tot = 0,
      //   this.format_impu = 0
      // }, 700)
    },
    // initialize () {
    //   this.$emit('getLogged', { context: this })
    // },
    reporte () {
      this.url = `${this.userLogged.company[0].id}/${this.startDate}/${this.finishDate}?type=download`
      if (!this.switchAllAreas) {
        this.url += `&areaId=${this.selectedArea}`
      }
      if (!this.switchAllCategories) {
        this.url += `&categoryId=${this.selectedCategory}`
      }
      if (!this.switchAllEmployees) {
        this.url += `&employeeId=${this.selectedEmployee}`
      }
      if (!this.switchAllProjects) {
        this.url += `&projectId=${this.selectedProject}`
      }
      this.loadingDownload = true
      this.$emit('downloadReport', {
        context: this,
        items: {
          url: this.url
        }
      })
    },
    closeDownloadDialog () {
      this.downloadZipDialog = false
      this.selectedZip = null
    },
    downloadFiles () {
      if (this.$refs.valDownload.validate()) {
        this.$emit('downloadFiles', {
          context: this,
          expensesItems: this.selectedZip,
          date: this.startDate.substr(0, 4)
        })
        this.loading = true
      }
    },
    dateFormat (date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    },
    calcTips (val) {
      let total = 0
      let data = val
      for (let i = 0; i < data.length - 1; i++) {
        if (data[i].total_tip) {
          total += parseFloat(data[i].total_tip)
        }
      }
      this.totalTipAll = total
      return total
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reportstype.component.vue